import ProfilesApi from "@/common/http/ProfilesApi";
import downloadBase64File from "@/common/misc/downloadBase64File";
import resumePdfParams from "@/common/misc/resumePdfParams";

// Fetches one candidate's resume PDF and hands it to the browser as a download.
//
// Lives outside the component so it can be tested directly: CandidateMenu.js imports a tree of
// SFCs whose templates the repo's jest template compiler can't parse, so anything reachable
// only through the component is untestable by construction.
//
// Returns whether a download was started. A candidate the backend can't render (a missing saved
// profile, or a recommendation that has aged out of the project cache) comes back as a 404 — a
// rejected promise the caller surfaces through the global error toast. The blob check is a
// defensive guard against an unexpected empty 200, not a documented success shape.
export default async function exportCandidateResumePdf(candidate, currentProject, options = {}) {
  const response = await ProfilesApi.resumePdf(resumePdfParams(candidate, currentProject, options));
  if (!response?.data?.blob) {
    return false;
  }

  downloadBase64File(response.data.blob, response.data.filename);
  return true;
}
